export default __webpack_public_path__ + "static/media/figure1.47dcc525.png";